import { gql } from '@apollo/client';
import Dispatch from '../Dispatcher'
import { of, merge, combineLatest } from 'rxjs'
import { map, filter, withLatestFrom, tap, mergeMap, startWith } from 'rxjs/operators'

import _ from 'lodash'

const fragment = `
  fragment Data on Location {
    id
    name   
    description
    breweries {
      id
      name
      description
      drinks {
        id
        name
        description
        average
        ratedDrinks {
          id
          rating
        }
      }
    }
  }
  `

const GET_LOCATIONS = gql`
  query locations {
    locations {
      ...Data
    }
  }
  ${fragment},
`;

const GET_USER = gql`
  query user($id: Int!) {
    user(id: $id) {
      id
    }
  }
`;

const CREATE_USER = gql`
  mutation createUser {
    createUser {
      uuid
    }
  }
`;

const MUTATION_RATE_DRINK = gql`
  mutation rateDrink($drink: Int! $rating: Int!) {
    rateDrink(drink: $drink rating: $rating) {
      ...Data
    }
  }
  ${fragment},
`;

merge(of(1), Dispatch.getAction('getLocations'))
.subscribe(e => Dispatch.nextAction('Request.locations', { type: 'query', query: GET_LOCATIONS, variables: { }, poll: REACT_APP_POLL_INTERVAL,  retry: REACT_APP_RETRY_INTERVAL }))

// Remove the immediate createUser dispatch
// Dispatch.nextAction('createUser')

// Initialize user if no token exists
of(1).pipe(
  map(() => localStorage.getItem('token')),
  filter(token => !token)
).subscribe(() => {
  Dispatch.nextAction('createUser')
})

Dispatch.getAction('createUser')
  .subscribe(e => {
    Dispatch.nextAction('Request.createUser', { 
      type: 'mutation', 
      query: CREATE_USER,
      variables: { }
    })
  })

Dispatch.getAction('Response.createUser')
  .pipe(
    filter(e => _.isNil(e.errors)),
    map(e => e.data.createUser)
  )
  .subscribe(user => {
    const token = user.uuid
    localStorage.setItem('token', token)
    console.log("token", token)
    Dispatch.nextAction('getLocations')
  })

Dispatch.getAction('login')
  .pipe(
  )
  .subscribe(e => {
    localStorage.setItem('token', e?.toUpperCase())
    Dispatch.nextAction('getLocations')
  })

  Dispatch.getAction('logout')
  .pipe(
  )
  .subscribe(e => {
    localStorage.removeItem('token')
    Dispatch.nextAction('getLocations')
  })

merge(Dispatch.getAction('Response.locations'), Dispatch.getAction('Response.rateDrink'))
.pipe(
  filter(e => _.isNil(e.errors)),
  map(e => e.data.locations ?? e.data.rateDrink)
)
.subscribe(e => Dispatch.nextState('locations', e))


Dispatch.getAction('RateBeer')
  .pipe(
    tap(e => console.log("afsdfdsa")),
tap(e => console.log(e)),
  )
  .subscribe(e => Dispatch.nextAction('Request.rateDrink', { type: 'mutation', query: MUTATION_RATE_DRINK, variables: { drink: parseInt(e.id), rating: e.value }, poll: REACT_APP_POLL_INTERVAL,  retry: REACT_APP_RETRY_INTERVAL }))